export const CloseIcon = () => (
  <svg
    width="1em"
    viewBox="0 0 37 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      x2="27"
      y2="27"
      transform="translate(5 5.5)"
      fill="none"
      stroke="white"
      strokeWidth="2"
    />
    <line
      x2="27"
      y2="27"
      transform="translate(32 5.5) rotate(90)"
      fill="none"
      stroke="white"
      strokeWidth="2"
    />
  </svg>
)
